import { z } from 'zod';

/**
 * The supported locales (U8). Arabic is the DEFAULT experience, not a
 * translation of an English original — `ar` is deliberately first.
 *
 * Adding a locale means adding it here and shipping a complete key tree for it
 * in every client catalog plus a row in every `*_translations` table (N5).
 */
export const LOCALES = ['ar', 'en'] as const;

export const LocaleSchema = z.enum(LOCALES);

export type Locale = (typeof LOCALES)[number];

/** The default locale, used whenever a user/device preference is absent. */
export const DEFAULT_LOCALE: Locale = 'ar';

/** Text direction per locale — consumed by the clients at boot (M6, U7). */
export const LOCALE_DIRECTION: Readonly<Record<Locale, 'rtl' | 'ltr'>> = {
  ar: 'rtl',
  en: 'ltr',
};

/** Narrows an arbitrary string to a supported locale. */
export function isLocale(value: string): value is Locale {
  return LocaleSchema.safeParse(value).success;
}
